import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconKeyV2: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill || '#262626';

  return (
    <Icon {...props}>
      <path
        d="M19.79 14.9299C17.73 16.9799 14.78 17.6099 12.19 16.7999L7.48002 21.4999C7.14002 21.8499 6.47002 22.0599 5.99002 21.9899L3.81002 21.6899C3.09002 21.5899 2.42002 20.9099 2.31002 20.1899L2.01002 18.0099C1.94002 17.5299 2.17002 16.8599 2.50002 16.5199L7.20002 11.8199C6.40002 9.21995 7.02002 6.26995 9.08002 4.21995C12.03 1.26995 16.82 1.26995 19.78 4.21995C22.74 7.16995 22.74 11.9799 19.79 14.9299Z"
        stroke={fill}
        stroke-width="2.3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="white"
      />
      <path
        d="M6.89001 17.49L9.19001 19.79"
        stroke={fill}
        stroke-width="2.3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="white"
      />
      <path
        d="M14.5 11C15.3284 11 16 10.3284 16 9.5C16 8.67157 15.3284 8 14.5 8C13.6716 8 13 8.67157 13 9.5C13 10.3284 13.6716 11 14.5 11Z"
        stroke={fill}
        stroke-width="2.3"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="white"
      />
    </Icon>
  );
};

export default IconKeyV2;
